import { Array } from '@common/Array/Array'

import { is } from '@common/is/is'

import type { TLevelOptions, TEduBackground } from '../definitions'

import { EDU_BACKGROUND_TYPES, REQUIRED_EDU_MODULAR_OPTION_KEYS } from '../definitions'

import getValueByOptionKey from './getValueByOptionKey'

/**
 * Edu GamePage elkérése.
 * @param moduleOptions - A moduláris szintopciók.
 */
export default function getEduGamePage (moduleOptions: TLevelOptions): HTMLElement {
  // ezen kulcsú szintopciók nem a játék komponensére kerülnek fel
  const possibleGamePageKeys = [ ...REQUIRED_EDU_MODULAR_OPTION_KEYS, 'roundNum'  ]

  const gamePageModuleOptions = moduleOptions.filter((mo) => possibleGamePageKeys.includes(mo.optionKey))

  const gameType = getValueByOptionKey(gamePageModuleOptions, 'game-type')

  // ha nincs game-type megadva, akkor valamit elszúrtunk.
  if (is.undefined(gameType)) {
    throw new Error('Modulárisan indított Edu appnak kötelező a game-type szint-opció!')
  }

  const gameEl = document.createElement(`edu-${ gameType }-game`)

  // Azon szintopciók, amelyek a game elem-re kerülnek fel.
  const otherModuleOptions = moduleOptions.filter((mo) => !possibleGamePageKeys.includes(mo.optionKey))

  otherModuleOptions.forEach((option) => {
    gameEl.setAttribute(option.optionKey, option.optionValue)
  })

  const backgroundValue = getValueByOptionKey(gamePageModuleOptions, 'background') ?? 'table'

  // ha valid a bg value, akkor beállítjuk, egyébként a „table” a fallback.
  const background: TEduBackground = Array.includes(EDU_BACKGROUND_TYPES, backgroundValue)
    ? backgroundValue
    : 'table'

  const roundNumLevelOption = gamePageModuleOptions.find((option) => option.optionKey === 'roundNum')

  const roundNumValue = roundNumLevelOption?.optionValue

  const gamePage = document.createElement('edu-game-page')

  gamePage.appendChild(gameEl)
  gamePage.setAttribute('background', background)

  if (is.numeric(roundNumValue)) {
    gamePage.setAttribute('roundNum', roundNumValue)
  }

  return gamePage
}
